import { composeQuery, Query } from '../models/query';
import {
  DataResponse,
  Feature,
  PageableResponse,
  Subscription,
} from '../models';
import { ceV2Axios } from './axios';

export const toggleAutoRenew = async (recurlySubscriptionId: number) => (await ceV2Axios.put<boolean>(`/subscriptions/toggle-auto-renewal/${recurlySubscriptionId}`)).data;

export const getSubscriptions = async (...criteria: Query<Subscription>[]) => (
  await ceV2Axios.get<PageableResponse<Subscription>>('/subscriptions', {
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
    },
    params: composeQuery<Subscription>(...criteria),
    data: {},
  })
).data.data;

export const getKseEcomEligible = async () => (await ceV2Axios.get<DataResponse<boolean>>('/subscriptions/kse-ecom-eligible')).data.data;

export type EcomEligibility = Partial<Record<Feature, boolean>>;

/**
 * Per-feature eCom channel eligibility of the current account, keyed by the BE feature enum
 * NAME (which equals the FE `Feature` value for every ECOM_FEATURES member). Eligible = the ecom
 * plan pair is seeded AND the account holds no active legacy subscription of that feature.
 */
export const getEcomEligibility = async (): Promise<EcomEligibility> => (
  (await ceV2Axios.get<DataResponse<Record<string, boolean>>>('/subscriptions/ecom-eligible'))
    .data.data ?? {}
) as EcomEligibility;
